import { useAutoApprovedQualifications } from "@src/appV2/Licenses/useAutoApprovedQualifications";
import { ALL_QUALIFICATIONS_CATEGORY } from "@src/appV2/Qualifications/Categories/constants";
import { useGetQualificationsByCategories } from "@src/appV2/Qualifications/Categories/useGetQualificationsByCategories";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useWorkerQualifications } from "@src/appV2/Worker/useWorkerQualifications";
import { useRef } from "react";

import { useGetCredentialRequirementsForWorker } from "../../Documents/useGetCredentialRequirementsForWorker";

export function useAddRolesData() {
  const workerQualifications = useWorkerQualifications();
  const autoApprovedQualifications = useAutoApprovedQualifications();

  const {
    qualificationNameToCredentialMap,
    isInitialLoading: isInitialLoadingCredentialRequirements,
  } = useGetCredentialRequirementsForWorker([...autoApprovedQualifications]);

  const {
    data: qualificationsByCategories,
    isLoading: qualificationsAreLoading,
    isSuccess: qualificationsAreLoaded,
    isError: qualificationsAreError,
  } = useGetQualificationsByCategories();

  const { userId: workerId, shoppableQualifications } = useDefinedWorker();

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const workerQualificationIds = workerQualifications.data?.map((q) => q.id) ?? [];

  return {
    allQualifications: qualificationsByCategories?.[ALL_QUALIFICATIONS_CATEGORY] ?? [],
    qualificationsByCategories: qualificationsByCategories ?? {
      [ALL_QUALIFICATIONS_CATEGORY]: [],
    },
    qualificationsAreLoading: qualificationsAreLoading || isInitialLoadingCredentialRequirements,
    qualificationsAreLoaded: qualificationsAreLoaded && !isInitialLoadingCredentialRequirements,
    qualificationsAreError,
    autoApprovedQualifications,
    workerId,
    scrollContainerRef,
    workerQualificationIds,
    shoppableQualifications,
    qualificationNameToCredentialMap,
  };
}
